module.exports = __webpack_public_path__ + "img/BS14.aaa27b11.svg";